module.exports = __webpack_public_path__ + "media/images/preloader-train-f28544c98bdf3b93719188baacf461d4.svg";